/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useEffect, useMemo } from 'react';
import { message } from 'antd';
import { axiosErp } from 'shared/config/axios';
import { getStoredAuthToken } from 'shared/utils/authToken';
import { SaveOutlined } from '@ant-design/icons';
import { useFormContext, Controller } from 'react-hook-form';
import { useQueryClient } from 'react-query';
import formatCurrency from 'shared/utils/formatCurrency';
import { formatDateTime } from 'shared/utils/dateTime';

import { v4 as uuidv4 } from 'uuid';
import { TableCosting, InputNumberFormat } from 'shared/components';
import { StyledButton, StyledContainerButton, StyledFormItem } from './Styles';
import { FormValues } from './formValues.model';

type RevenueTableProps = {
  haierCostData: any;
};

const RevenueTable: React.FC<RevenueTableProps> = ({ haierCostData }) => {
  const { control, trigger } = useFormContext<FormValues>();
  const token = getStoredAuthToken();
  const queryClient = useQueryClient();

  const [priceSale, setPriceSale] = useState<any[]>([]);
  const [priceSaleOnBlur, setPriceSaleOnBlur] = useState<boolean>(false);
  const [totalSalePrice, setTotalSalePrice] = useState<number[]>([]);
  const [priceSaleOnChange, setPriceSaleOnChange] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);
  const {
    _id,
    order,
    jobNumber,
    truckType,
    driver,
    licensePlate,
    tripNo,
    vendor,
    cost,
    revenue,
    grandTotal,
  } = haierCostData;

  const changeNumberFormat = (value: number) => {
    return value.toFixed(2);
  };

  const getValueFormNumber = (value: number | undefined) => {
    if (typeof value === 'number') {
      return changeNumberFormat(value);
    }
    return undefined;
  };

  const onChangePriceSale = (index, name, value) => {
    setPriceSaleOnChange(true);
    setPriceSale((prevPriceSale) => {
      const updatedPriceSale = [...(prevPriceSale || [])];
      console.log('Updating priceSale:', index, name, value);
      updatedPriceSale[index][name] = value;
      return updatedPriceSale;
    });
  };

  const columnsTableService = [
    {
      title: 'Order Info.',
      align: 'left',
      style: {
        padding: '6px',
        backgroundColor: '#F6F6F6',
        margin: '-6px',
      },
      children: [
        {
          title: 'Order No.',
          dataIndex: 'orderNo',
          key: 'orderNo',
          width: 130,
        },
        {
          title: 'Pickup Name',
          dataIndex: 'pickupName',
          key: 'pickupName',
          width: 100,
        },
        {
          title: 'Pickup Provinces',
          dataIndex: 'pickupProvince',
          key: 'pickupProvince',
          width: 130,
        },
        {
          title: 'Consignee Name',
          dataIndex: 'consigneeName',
          key: 'consigneeName',
          width: 130,
        },
        {
          title: 'Type',
          dataIndex: 'type',
          key: 'type',
          width: 80,
        },
        {
          title: 'Pricing Type',
          dataIndex: 'pricingType',
          key: 'pricingType',
          width: 120,
        },
        {
          title: 'Billing Month',
          dataIndex: 'billingMonth',
          key: 'billingMonth',
          width: 120,
        },
        {
          title: 'Delivery Province',
          dataIndex: 'deliveryProvince',
          key: 'deliveryProvince',
          width: 150,
        },
        {
          title: 'Delivery Zone',
          dataIndex: 'deliveryZone',
          key: 'deliveryZone',
          width: 120,
        },
        {
          title: 'Material Description',
          dataIndex: 'itemName',
          key: 'itemName',
          width: 300,
        },
        {
          title: 'Order CBM',
          dataIndex: 'cbm',
          key: 'cbm',
          width: 100,
        },
        {
          title: 'Order QTY',
          dataIndex: 'quantity',
          key: 'quantity',
          width: 100,
        },
        {
          title: 'Lift Qty',
          dataIndex: 'liftQuantity',
          key: 'liftQuantity',
          width: 100,
        },
        {
          title: 'Unpack Qty',
          dataIndex: 'unpackQuantity',
          key: 'unpackQuantity',
          width: 100,
        },
        {
          title: 'Other Service Qty',
          dataIndex: 'otherServiceQuantity',
          key: 'otherServiceQuantity',
          width: 130,
        },
        {
          title: 'RT Qty',
          dataIndex: 'rtQuantity',
          key: 'rtQuantity',
          width: 100,
        },
        {
          title: 'RT Name',
          dataIndex: 'rtName',
          key: 'rtName',
          width: 100,
        },
      ],
    },
    {
      title: 'Trip & Job Info.',
      align: 'left',
      style: {
        padding: '6px',
        backgroundColor: '#F6F6F6',
        margin: '-6px',
      },
      children: [
        {
          title: 'Trip No',
          dataIndex: 'tripNo',
          key: 'tripNo',
          width: 120,
        },
        {
          title: 'Loaded Date',
          dataIndex: 'pickupDate',
          key: 'pickupDate',
          width: 180,
        },
        {
          title: 'Delivered Date',
          dataIndex: 'deliveryDate',
          key: 'deliveryDate',
          width: 180,
        },
        {
          title: 'Job No.',
          dataIndex: 'jobNumber',
          key: 'jobNumber',
          width: 160,
        },
        {
          title: 'Vendor Code',
          dataIndex: 'vendorName',
          key: 'vendorName',
          width: 280,
        },
        {
          title: 'Truck Types',
          dataIndex: 'truckType',
          key: 'truckType',
          width: 150,
        },
        {
          title: 'License Plates',
          dataIndex: 'licensePlate',
          key: 'licensePlate',
          width: 120,
        },
        {
          title: 'Driver Names',
          dataIndex: 'driver',
          key: 'driver',
          width: 150,
        },
      ],
    },
    {
      title: 'Transport Revenue Info.',
      align: 'left',
      style: {
        padding: '6px',
        alignItems: 'flex-end',
        backgroundColor: '#74B662',
        margin: '-6px',
      },
      children: [
        {
          title: 'Transport',
          dataIndex: 'revenuePrice',
          key: 'revenuePrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'Total ',
          dataIndex: 'revenueTotalPrice',
          key: 'revenueTotalPrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
      ],
    },
    {
      title: 'Service Revenue Info.',
      align: 'left',
      style: {
        padding: '6px',
        alignItems: 'flex-end',
        backgroundColor: '#74B662',
        margin: '-6px',
      },
      children: [
        {
          title: 'จำนวนชั้นที่ยก',
          dataIndex: 'revenueCarryHight',
          key: 'revenueCarryHight',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'ค่ายก',
          dataIndex: 'revenueCarry',
          key: 'revenueCarry',
          width: 80,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'OT',
          dataIndex: 'revenueOT',
          key: 'revenueOT',
          width: 80,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'Return',
          dataIndex: 'returnFee',
          key: 'returnFee',
          width: 120,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'Unpack',
          dataIndex: 'revenueUnpack',
          key: 'revenueUnpack',
          width: 80,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'Label',
          dataIndex: 'revenueLabel',
          key: 'revenueLabel',
          width: 80,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'Fuel (1%)',
          dataIndex: 'revenueFuel',
          key: 'revenueFuel',
          width: 80,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'WH',
          dataIndex: 'revenueWH',
          key: 'revenueWH',
          width: 80,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'Other',
          dataIndex: 'revenueOther',
          key: 'revenueOther',
          width: 80,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'Total',
          dataIndex: 'revenueTotal',
          key: 'revenueTotal',
          width: 80,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
      ],
    },
  ];

  const sumPriceAll = () => {
    setTotalSalePrice(
      priceSale.map((priceObj) => {
        return (
          (Number(priceObj.carry) || 0) +
          (Number(priceObj.ot) || 0) +
          (Number(priceObj.returnFee) || 0) +
          (Number(priceObj.unpack) || 0) +
          (Number(priceObj.label) || 0) +
          (Number(priceObj.fuel) || 0) +
          (Number(priceObj.wh) || 0) +
          (Number(priceObj.other) || 0)
        );
      }),
    );
  };

  const sumPrice = (priceObj) => {
    return (
      (Number(priceObj.carry) || 0) +
      (Number(priceObj.ot) || 0) +
      (Number(priceObj.returnFee) || 0) +
      (Number(priceObj.unpack) || 0) +
      (Number(priceObj.label) || 0) +
      (Number(priceObj.fuel) || 0) +
      (Number(priceObj.wh) || 0) +
      (Number(priceObj.other) || 0)
    );
  };

  const dataTableService = useMemo(
    () =>
      order.map((item, index) => ({
        key: `revenue-table-${item._id || uuidv4()}`,
        orderNo: item.orderNo,
        pickupName: item.pickupName,
        pickupProvince: item.pickupProvince,
        consigneeName: item.consigneeName,
        type: item.type,
        pricingType: item.pricingType,
        billingMonth: item.billingMonth,
        deliveryProvince: item.deliveryProvince,
        deliveryZone: item.deliveryZone,
        cbm: (
          <div
            style={{
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceSale[${index}].cbm`}
                render={({ onChange, onBlur }) => (
                  <InputNumberFormat
                    value={priceSale && priceSale[index] ? priceSale[index].cbm : item.cbm || 0}
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceSale[${index}].cbm`]);
                      onChangePriceSale(index, 'cbm', valueChange.floatValue);
                    }}
                    decimalScale={3}
                    placeholder="0.000"
                    onBlur={() => {
                      onBlur();
                      setPriceSaleOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        itemName: item.itemName,
        quantity: item.quantity,
        liftQuantity: item.liftQuantity,
        unpackQuantity: item.unpackQuantity,
        otherServiceQuantity: item.otherServiceQuantity || 0,
        rtQuantity: item.rtQuantity,
        rtName: item.rtName,
        tripNo,
        pickupDate: formatDateTime(item.pickupDate),
        deliveryDate: formatDateTime(item.deliveryDate),
        jobNumber,
        vendorName: vendor.vendorName,
        truckType,
        licensePlate,
        driver,
        costPrice: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {index === 0 ? formatCurrency(Number(cost), '-') : '-'}
          </div>
        ),
        totalCostPrice: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {index === 0 ? formatCurrency(Number(grandTotal.cost), '-') : '-'}
          </div>
        ),
        costOT: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceCost?.ot || 0), '-')}
          </div>
        ),
        costUnpack: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceCost?.unpack || 0), '-')}
          </div>
        ),
        costLabel: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceCost?.label || 0), '-')}
          </div>
        ),
        costOther: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(Number(item.priceCost?.other || 0), '-')}
          </div>
        ),
        costTotal: (
          <div
            style={{
              backgroundColor: '#FFF8E1',
              margin: '-6px',
              padding: '6px',
            }}
          >
            {formatCurrency(
              Number(totalSalePrice[index] || sumPrice(item.priceCost) || '0.00'),
              '0.00',
            )}
          </div>
        ),
        revenuePrice: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '13px 6px',
            }}
          >
            {item.pricingType === 'CBM Rate'
              ? formatCurrency(item.priceSale.transport)
              : index === 0
              ? formatCurrency(Number(revenue), '-')
              : '-'}
          </div>
        ),
        revenueTotalPrice: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '13px 6px',
            }}
          >
            {index === 0 ? formatCurrency(Number(revenue), '-') : '-'}
          </div>
        ),
        revenueCarryHight: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceSale[${index}].carryHight`}
                defaultValue={item.carryHight || '0'}
                render={({ value, onChange, onBlur }) => (
                  <InputNumberFormat
                    value={priceSale && priceSale[index] ? priceSale[index].carryHight : value}
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceSale[${index}].carryHight`]);
                      onChangePriceSale(index, 'carryHight', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setPriceSaleOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        revenueCarry: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceSale[${index}].carry`}
                defaultValue={item.priceSale?.carry || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceSale && priceSale[index] ? priceSale[index].carry : value}
                    onValueChange={(valueChange) => {
                      onChange(valueChange.floatValue);
                      trigger([`priceSale[${index}].carry`]);
                      onChangePriceSale(index, 'carry', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setPriceSaleOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        revenueOT: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceSale[${index}].ot`}
                defaultValue={item.priceSale?.ot || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceSale && priceSale[index] ? priceSale[index].ot : value}
                    onValueChange={(valueChange) => {
                      onChange(getValueFormNumber(valueChange.floatValue));
                      trigger([`priceSale[${index}].ot`]);
                      onChangePriceSale(index, 'ot', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setPriceSaleOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        returnFee: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceSale[${index}].returnFee`}
                defaultValue={item.priceSale?.returnFee || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceSale && priceSale[index] ? priceSale[index].returnFee : value}
                    onValueChange={(valueChange) => {
                      onChange(getValueFormNumber(valueChange.floatValue));
                      trigger([`priceSale[${index}].returnFee`]);
                      onChangePriceSale(index, 'returnFee', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setPriceSaleOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        revenueUnpack: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceSale[${index}].unpack`}
                defaultValue={item.priceSale?.unpack || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceSale && priceSale[index] ? priceSale[index].unpack : value}
                    onValueChange={(valueChange) => {
                      onChange(getValueFormNumber(valueChange.floatValue));
                      trigger([`priceSale[${index}].unpack`]);
                      onChangePriceSale(index, 'unpack', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setPriceSaleOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        revenueLabel: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceSale[${index}].label`}
                defaultValue={item.priceSale?.label || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceSale && priceSale[index] ? priceSale[index].label : value}
                    onValueChange={(valueChange) => {
                      onChange(getValueFormNumber(valueChange.floatValue));
                      trigger([`priceSale[${index}].label`]);
                      onChangePriceSale(index, 'label', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setPriceSaleOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        revenueFuel: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceSale[${index}].fuel`}
                defaultValue={item.priceSale?.fuel || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceSale && priceSale[index] ? priceSale[index].fuel : value}
                    onValueChange={(valueChange) => {
                      onChange(getValueFormNumber(valueChange.floatValue));
                      trigger([`priceSale[${index}].fuel`]);
                      onChangePriceSale(index, 'fuel', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setPriceSaleOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        revenueWH: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceSale[${index}].wh`}
                defaultValue={item.priceSale?.wh || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceSale && priceSale[index] ? priceSale[index].wh : value}
                    onValueChange={(valueChange) => {
                      onChange(getValueFormNumber(valueChange.floatValue));
                      trigger([`priceSale[${index}].wh`]);
                      onChangePriceSale(index, 'wh', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setPriceSaleOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        revenueOther: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '6px',
            }}
          >
            <StyledFormItem>
              <Controller
                control={control}
                name={`priceSale[${index}].other`}
                defaultValue={item.priceSale?.other || '0'}
                render={({ onChange, value, onBlur }) => (
                  <InputNumberFormat
                    value={priceSale && priceSale[index] ? priceSale[index].other : value}
                    onValueChange={(valueChange) => {
                      onChange(getValueFormNumber(valueChange.floatValue));
                      trigger([`priceSale[${index}].other`]);
                      onChangePriceSale(index, 'other', valueChange.floatValue);
                    }}
                    decimalScale={0}
                    placeholder="0"
                    onBlur={() => {
                      onBlur();
                      setPriceSaleOnBlur(true);
                    }}
                  />
                )}
              />
            </StyledFormItem>
          </div>
        ),
        revenueTotal: (
          <div
            style={{
              backgroundColor: '#EDF9E9',
              margin: '-6px',
              padding: '12px 6px',
              height: '45px',
            }}
          >
            {formatCurrency(
              Number(totalSalePrice[index] || sumPrice(item.priceSale) || '0.00'),
              '0.00',
            )}
          </div>
        ),
      })),
    [totalSalePrice, priceSale],
  );

  const onSubmitRevenueTable = async () => {
    setIsLoading(true);
    try {
      const objUpdate = order.map((item, index) => {
        return {
          ...item,
          cbm:
            priceSale && priceSale[index] && priceSale[index].cbm !== undefined
              ? priceSale[index].cbm
              : item.cbm || 0,
          carryHight:
            priceSale && priceSale[index] ? priceSale[index].carryHight : item.carryHight || 0,
          priceSale: {
            carry:
              priceSale && priceSale[index] ? priceSale[index].carry : item.priceSale?.carry || 0,
            ot: priceSale && priceSale[index] ? priceSale[index].ot : item.priceSale?.ot || 0,
            returnFee:
              priceSale && priceSale[index]
                ? priceSale[index].returnFee
                : item.priceSale?.returnFee || 0,
            unpack:
              priceSale && priceSale[index] ? priceSale[index].unpack : item.priceSale?.unpack || 0,
            label:
              priceSale && priceSale[index] ? priceSale[index].label : item.priceSale?.label || 0,
            fuel: priceSale && priceSale[index] ? priceSale[index].fuel : item.priceSale?.fuel || 0,
            wh: priceSale && priceSale[index] ? priceSale[index].wh : item.priceSale?.wh || 0,
            other:
              priceSale && priceSale[index] ? priceSale[index].other : item.priceSale?.other || 0,
            transport:
              priceSale && priceSale[index]
                ? priceSale[index].transport
                : item.priceSale?.transport || 0,
          },
        };
      });
      await axiosErp(token).post(`update-costing-trip-turboo`, {
        filter: { _id },
        update: { order: objUpdate },
      });

      await queryClient.refetchQueries(['costing-job-detail', _id]);
      setIsLoading(false);
    } catch (e) {
      message.error(e.message || 'เกิดข้อผิดพลาดในการแก้ไขรายได้');
      console.error('ERROR TO LOAD COSTING DETAIL: ', e);
    } finally {
      message.success('ยืนยันการแก้ไขรายได้เรียบร้อยแล้ว');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isLoading && priceSale.length === 0) {
      setPriceSale(
        order.map((item, index) => {
          const existingPriceSale =
            priceSale && priceSale[index] ? priceSale[index] : item.priceSale || {};
          return {
            _id: item._id,
            carryHight: item.carryHight,
            carry: existingPriceSale.carry || '0',
            ot: existingPriceSale.ot || '0',
            returnFee: existingPriceSale.returnFee || '0',
            unpack: existingPriceSale.unpack || '0',
            label: existingPriceSale.label || '0',
            fuel: existingPriceSale.fuel || '0',
            wh: existingPriceSale.wh || '0',
            other: existingPriceSale.other || '0',
            transport: existingPriceSale.transport || '0',
            cbm: priceSale[index]?.cbm !== undefined ? priceSale[index].cbm : item.cbm || 0,
          };
        }),
      );
      setIsLoading(false);
    } else if (priceSaleOnBlur) {
      sumPriceAll();
      setPriceSaleOnBlur(false);
    }
  }, [order, priceSale, priceSaleOnBlur]);
  return (
    <>
      <StyledContainerButton style={{ alignContent: 'flex-end' }}>
        <StyledButton
          disabled={isLoading || !priceSaleOnChange}
          icon={<SaveOutlined />}
          color="green"
          onClick={() => onSubmitRevenueTable()}
        >
          บันทึกรายได้
        </StyledButton>
      </StyledContainerButton>
      <TableCosting
        bordered
        className="table-1"
        pagination={false}
        columns={columnsTableService}
        dataSource={dataTableService}
      />
    </>
  );
};

export default RevenueTable;
